<template>
    <div id="home-wallet-features">
        <div class="wallet-illustration-wrapper">
            <div class="illustration-container">
                <img class="wallet-web-illustration" src="/images/elements/home/web/wallet-features-illustration.png"
                    alt="wallet-illustration" />
            </div>
        </div>
        <div class="content-container">
            <div class="content-inner">
                <div class="content-section">
                    <div class="title headline-l" v-html="$t('homeScreen.walletFeatures.title')"></div>
                    <div class="wallet-illustration-mobile-wrapper">
                        <img class="wallet-mobile-illustration"
                            src="/images/elements/home/web/wallet-features-illustration.png"
                            alt="wallet-mobile-illustration" />
                    </div>
                    <div class="bottom-section">
                        <div class="subtitle text-l" v-html="$t('homeScreen.walletFeatures.subtitle')">
                        </div>
                        <div class="features-grid">
                            <div v-for="(feature, index) in features" :key="index" class="feature-box">
                                <div class="feature-header">
                                    <img :src="feature.icon" alt="" />
                                    <span class="feature-title">{{ feature.title }}</span>
                                </div>
                                <div class="feature-description">{{ feature.description }}</div>
                            </div>
                        </div>
                        <base-button class="join-button" :text="$t('homeScreen.walletFeatures.buttonText')" size="large"
                            type="light-green" @clicked="handleClick" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeWalletFeatures',
    props: {},
    components: {},
    data: () => ({}),
    created() { },
    computed: {
        features() {
            return [
                {
                    icon: '/images/icons/fast-green.svg',
                    title: this.$t('homeScreen.walletFeatures.features.topUp.title'),
                    description: this.$t('homeScreen.walletFeatures.features.topUp.description'),
                },
                {
                    icon: '/images/icons/circle-plus-green.svg',
                    title: this.$t('homeScreen.walletFeatures.features.purchase.title'),
                    description: this.$t('homeScreen.walletFeatures.features.purchase.description'),
                },
                {
                    icon: '/images/icons/asset-order-green.svg',
                    title: this.$t('homeScreen.walletFeatures.features.sendReceive.title'),
                    description: this.$t('homeScreen.walletFeatures.features.sendReceive.description'),
                },
                {
                    icon: '/images/icons/import-ethereum-green.svg',
                    title: this.$t('homeScreen.walletFeatures.features.bridge.title'),
                    description: this.$t('homeScreen.walletFeatures.features.bridge.description'),
                },
            ];
        },
    },
    methods: {
        handleClick() {
            this.$emit('buttonClicked');
        },
    },
};
</script>

<style lang="scss" scoped>
#home-wallet-features {
    position: relative;
    height: auto;
    min-height: 760px;
    width: 100%;
    border-bottom: 1px solid #6464FF;

    @media (max-width: $breakpoint-md) {
        min-height: fit-content;
        padding: 60px 0;
    }

    .wallet-illustration-mobile-wrapper {
        justify-content: center;
        display: flex;
        margin-bottom: $margin-s;
        height: 327px;
        width: 100%;

        @media (min-width: $breakpoint-md) {
            display: none;
        }

        .wallet-mobile-illustration {
            height: 327px;
            width: 100%;
            object-fit: cover;
        }
    }

    .wallet-illustration-wrapper {
        height: 100%;
        min-height: 760px;
        width: 100%;
        position: absolute;
        align-items: center;
        display: flex;

        @media (max-width: $breakpoint-md) {
            display: none;
        }

        .wallet-web-illustration {
            position: absolute;
            z-index: 1;
            left: 0;
            height: 760px;
            width: 514px;
            object-fit: cover;

            @media (max-width: $breakpoint-lg) {
                width: 450px;
            }

            @media (max-width: $breakpoint-xs) {
                position: relative;
            }
        }
    }

    .illustration-container {
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
    }

    .container {
        @media (min-width: $breakpoint-lg) {
            max-width: 1196px;
        }

        @media (max-width: $breakpoint-xs) {
            padding-left: 0px;
            padding-right: 0px;
        }
    }

    .content-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 760px;
        margin-left: 514px;
        padding-left: 30px;

        @media (max-width: $breakpoint-lg) {
            margin-left: 450px;
        }

        @media (max-width: $breakpoint-md) {
            margin-left: 0;
            padding-left: 0;
            height: auto;
        }

        .content-inner {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            z-index: 1;

            @media (max-width: $breakpoint-md) {
                align-items: center;
            }

            .content-section {
                padding-right: calc(((100vw - 1196px) / 2) + 15px);
                width: 100%;
                flex-direction: column;

                @media (max-width: $breakpoint-lg) {
                    padding-right: calc(((100vw - 960px) / 2) + 15px);
                }

                @media (max-width: $breakpoint-md) {
                    padding-right: 15px;
                    padding-left: 15px;
                    max-width: 720px;
                }
                @media (max-width: $breakpoint-sm) {
                    max-width: 540px;
                }
                @media (max-width: $breakpoint-xs) {
                    padding-left: 0px;
                    padding-right: 0px;
                }

                .title {
                    margin-bottom: 24px;
                    letter-spacing: 0em;
                    text-align: left;
                    text-transform: uppercase;

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                    }
                }

                .subtitle {
                    margin-bottom: 40px;
                    line-height: 28px;
                    text-align: left;

                    @media (max-width: $breakpoint-md) {
                        text-align: center;
                    }
                }

                .bottom-section {
                    @media (max-width: $breakpoint-xs) {
                        padding-left: 15px;
                        padding-right: 15px;
                    }
                }

                .features-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 30px;
                    margin-bottom: 40px;

                    @media (max-width: $breakpoint-sm) {
                        grid-template-columns: 1fr;
                        gap: 16px;
                    }

                    .feature-box {
                        .feature-header {
                            background: #4656FF;
                            ;
                            display: flex;
                            align-items: center;
                            margin-bottom: 20px;
                            gap: 8px;
                            padding: 14px;
                            @media (max-width: $breakpoint-sm) {
                                justify-content: center;
                            }
                            img {
                                width: 32px;
                                height: 32px;
                            }

                            .feature-title {
                                font-family: 'HKNova-Bold', sans-serif;
                                font-size: 16px;
                                font-weight: 700;
                                text-transform: uppercase;
                                color: $white;
                            }
                        }
                    }
                }

                .join-button {
                    text-transform: uppercase;
                    margin-left: auto;
                    display: block;

                    @media (max-width: $breakpoint-md) {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
